<script lang="ts" setup>
defineProps<{
  name: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}>();

const sizeClass = {
  xs: 'text-xs!',
  sm: 'text-base!',
  md: 'text-2xl!',
  lg: 'text-4xl!',
  xl: 'text-6xl!',
};
</script>

<template>
  <span class="material-icons" :class="size ? sizeClass[size] : ''">{{ name }}</span>
</template>
